// GA4 browser tag for the SPA. Manual page views (send_page_view:false) so React Router is the source of truth.
const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const enabled = process.env.REACT_APP_GA4_ENABLED === "true";

let initialized = false;
let lastPage = null;

function isPrerender() {
  return typeof window !== "undefined" && Boolean(window.__PRERENDER__);
}

export function initAnalytics() {
  if (initialized || !enabled || !measurementId || isPrerender()) return false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
  initialized = true;
  return true;
}

export function trackPageView(location) {
  if (!initialized || !window.gtag || !location) return;
  const path = `${location.pathname}${location.search}`;
  const loc = `${window.location.origin}${path}`;
  if (lastPage === loc) return;
  lastPage = loc;
  window.gtag("event", "page_view", { page_title: document.title, page_location: loc, page_path: path });
}

export function gaEvent(name, params = {}) {
  if (!initialized || !window.gtag) return;
  window.gtag("event", name, params);
}
